<template>
    <div class="left_nav">
      <div class="left_nav_items">
        <b-nav>
          <b-nav-item class="ace_sec_txt" v-if="showIntroductionTab" :disabled="!menuOptionsEnabled" @click="navigateToIntroductionView" :active="active === 'introduction'" aria-label="Introduction">
            {{ introductionTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" v-if="showCareerProspectsTab && !programGuideObject.disableLMI" :disabled="!menuOptionsEnabled" @click="navigateToCareerProspectsView" :active="active === 'careerProspects'" aria-label="Career Prospects">
            {{ careerProspectsTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" v-if="showDegreeRequirementsTab" :disabled="!menuOptionsEnabled" @click="navigateToDegreeRequirementsView" :active="active === 'degreeRequirements'" aria-label="Degree Requirements">
            {{ degreeRequirementsTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" v-if="showConcentrationTab" :disabled="!menuOptionsEnabled" @click="navigateToConcentrationView" :active="active === 'concentrations'" aria-label="Concentrations">
            Concentrations
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" v-if="showStreamsTab" :disabled="!menuOptionsEnabled" @click="navigateToStreamsView" :active="active === 'streams'" aria-label="Streams">
            {{ streamsTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" v-if="showAlumniInsightsTab" :disabled="!menuOptionsEnabled" @click="navigateToAlumniInsightsView" :active="active === 'alumniInsights'" aria-label="Alumni Insights">
            {{ alumniInsightsTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" :disabled="!menuOptionsEnabled" v-if="showRelatedProgramTab"  @click="navigateToRelatedProgramView" :active="active === 'relatedProgram'" aria-label="RelatedProgram">
            {{ relatedProgramTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" v-if="showMyProgramStatusTab" :disabled="!menuOptionsEnabled" @click="navigateToMyProgramStatusView" :active="active === 'programStatus'" aria-label="My Program Status">
            {{ showMyProgramStatusTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" v-if="showAlumniTab" :disabled="!menuOptionsEnabled" @click="navigateToSpotlightAlumniView" :active="active === 'spotlightAlumni'" aria-label="Alumni">
            Alumni
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" :disabled="!menuOptionsEnabled" v-if="showFAQTab"  @click="navigateToFAQView" :active="active === 'FAQ'" aria-label="FAQ">
            {{ FAQTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" :disabled="!menuOptionsEnabled" v-if="showComplianceTab"  @click="navigateToComplianceView" :active="active === 'compliance'" aria-label="FAQ">
            {{ complianceTabLabel }}
          </b-nav-item>
          <b-nav-item class="ace_sec_txt" :disabled="!menuOptionsEnabled" v-if="isAdmin"  @click="navigateToEnrollmentView" :active="active === 'enrollment'" aria-label="enrollment">
            Enrollments
          </b-nav-item>
        </b-nav>
      </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'programGuideMenu',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'active', 'isWidget', 'selected'],
  data: () => {
    return {
      alumniData: {},
      introduction: 'introduction',
      careerProspects: 'careerProspects',
      degreeRequirements: 'degreeRequirements',
      streams: 'streams',
      alumniInsights: 'alumniInsights',
      staff: 'staff',
      relatedProgram: 'relatedProgram',
      jobs: 'jobs',
      careers: 'careers',
      configuration: 'configuration',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults'
    }
  },
  async beforeMount () {
    this.alumniData = await this.loadProgramAlumniData(this.$parent.programGuideCode)
  },
  mounted () {
    this.$parent.showBackToResultButton = (this.$route.query.returnTo !== 'careerPrograms')
  },

  updated () {
    // detect stale state and update programGuide if needed.
    let propCipCode = this.cipCode
    let stateCipCode = this.programGuideObject ? this.programGuideObject.cipCode : ''
    if (propCipCode && stateCipCode && propCipCode === stateCipCode) {
      return
    }
    this.loadProgramGuide({
      cipCode: this.cipCode,
      programGuideCode: this.programGuideCode,
      type: this.type,
      loadDataFromServer: true
    })
    this.$forceUpdate()
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity',
      'loadProgramGuide',
      'loadProgramAlumniData'
    ]),
    navigateToIntroductionView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideIntroduction', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToCareerProspectsView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideCareerProspects', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToDegreeRequirementsView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideDegreeRequirements', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToStreamsView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideStreams', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToCareersView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideCareers', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToAlumniInsightsView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideAlumniInsights', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToStaffView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideStaff', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToRelatedProgramView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideRelatedProgram', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToFAQView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideFAQ', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToComplianceView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideCompliance', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToEnrollmentView (){
      return this.$router.push({ name: 'programGuideEnrollment', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToJobsView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideJobs', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToConcentrationView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideConcentration', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToMyProgramStatusView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideMyProgramStatus', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToSpotlightAlumniView () {
      if (!this.menuOptionsEnabled) return
      return this.$router.push({ name: 'programGuideSpotlightAlumni', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    }
  },

  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'packages': state => state.institution.packages,
      'permission': state => state.user.permission,
      'programGuideObject': state => state.programguide.programGuideObject,
      'learnerDashboardState': state => state.dashboard.learnerDashboardState,
      'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData
    }),
    isAdmin () {
        return (localStorage.getItem('userrole') === 'Instructor & Admin')
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    showIntroductionTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.introductionTab) {
        return false
      }
      return exploreProgramDetailFlagMap.introductionTab.enabled
    },
    introductionTabLabel () {
      const defaultLabel = 'Introduction'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.introduction){
          return this.programGuideObject.tabLabelMap.introduction
      }

      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.introductionTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.introductionTab.label || defaultLabel
    },
    showCareerProspectsTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careerProspectsTab) {
        return false
      }
      return exploreProgramDetailFlagMap.careerProspectsTab.enabled
    },
    careerProspectsTabLabel () {
      const defaultLabel = 'Career Prospects'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.careerProspects){
          return this.programGuideObject.tabLabelMap.careerProspects
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careerProspectsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.careerProspectsTab.label || defaultLabel
    },
    showDegreeRequirementsTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.degreeRequirementsTab) {
        return false
      }
      if (exploreProgramDetailFlagMap && exploreProgramDetailFlagMap.hideRequirementWithProgress && exploreProgramDetailFlagMap.hideRequirementWithProgress.enabled) {
        return !this.showMyProgramStatusTab
      }

      if(exploreProgramDetailFlagMap.degreeRequirementsTab.enabled){
        let programGuide = this.programGuideObject
        let haveCourses = (programGuide.categories && programGuide.categories.length >0)
        let haveCocur = (programGuide.cocurricularRequirement && programGuide.cocurricularRequirement.length >0)
        let haveEducations = (programGuide.educationRequirement && programGuide.educationRequirement.length >0)
        if(haveCourses || haveCocur || haveEducations) {
          return true
        }
      }
      return false
    },
    degreeRequirementsTabLabel () {
      const defaultLabel = 'Requirements'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.requirements){
          return this.programGuideObject.tabLabelMap.requirements
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.degreeRequirementsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.degreeRequirementsTab.label || defaultLabel
    },
    relatedProgramTabLabel () {
      const defaultLabel = 'Related Programs'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.relatedPrograms){
          return this.programGuideObject.tabLabelMap.relatedPrograms
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.relatedProgramsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.relatedProgramsTab.label || defaultLabel
    },
    FAQTabLabel () {
      const defaultLabel = 'FAQ'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.faqLabel){
          return this.programGuideObject.tabLabelMap.faqLabel
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.faqTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.faqTab.label || defaultLabel
    },
    showStreamsTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.streamsTab) {
        return false
      }
      return exploreProgramDetailFlagMap.streamsTab.enabled
    },
    streamsTabLabel () {
      const defaultLabel = 'Pathways'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.pathways){
          return this.programGuideObject.tabLabelMap.pathways
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.streamsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.streamsTab.label || defaultLabel
    },
    showCareersTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careersTab) {
        return false
      }
      return exploreProgramDetailFlagMap.careersTab.enabled
    },
    careersTabLabel () {
      const defaultLabel = 'Careers'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.careers){
          return this.programGuideObject.tabLabelMap.careers
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.careersTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.careersTab.label || defaultLabel
    },
    showAlumniInsightsTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.alumniInsightsTab) {
        return false
      }
      return exploreProgramDetailFlagMap.alumniInsightsTab.enabled
    },
    alumniInsightsTabLabel () {
      const defaultLabel = 'Alumni Insights'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.alumniInsights){
          return this.programGuideObject.tabLabelMap.alumniInsights
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.alumniInsightsTab) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.alumniInsightsTab.label || defaultLabel
    },
    menuOptionsEnabled () {
      let activePage = this.active
      return activePage && activePage.length > 0
    },
    showConcentrationTab () {
      let programGuide = this.programGuideObject
      if (programGuide.concentrations && programGuide.concentrations.length > 0) {
        return true
      }
      return false
    },
    showRelatedProgramTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.relatedProgramsTab) {
        return false
      }

      if (exploreProgramDetailFlagMap.relatedProgramsTab.enabled) {
        let programGuide = this.programGuideObject
        if (programGuide.relatedPrograms && programGuide.relatedPrograms.length > 0) {
          return true
        }
      }
      return false
    },
    showFAQTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.faqTab) {
        return false
      }

      if (exploreProgramDetailFlagMap.faqTab.enabled) {
        let programGuide = this.programGuideObject
        if (programGuide.faqGroup && programGuide.faqGroup.faqGroups && programGuide.faqGroup.faqGroups.length > 0) {
          return true
        }
      }
      return false
    },
    showComplianceTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.institutionSpecificInfo) {
        return false
      }

      if (exploreProgramDetailFlagMap.institutionSpecificInfo.enabled) {
        let programGuide = this.programGuideObject

        if (this.programGuideObject.institutionSpecificInfo && this.programGuideObject.institutionSpecificInfo.subGroups && this.programGuideObject.institutionSpecificInfo.subGroups.length > 0) {
          return true
        }
      }
      return false
    },
    complianceTabLabel () {
      const defaultLabel = 'Institution Info'
      if(this.programGuideObject.tabLabelMap && this.programGuideObject.tabLabelMap.institutionSpecificInfoLabel){
          return this.programGuideObject.tabLabelMap.institutionSpecificInfoLabel
      }
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.institutionSpecificInfo) {
        return defaultLabel
      }
      return exploreProgramDetailFlagMap.institutionSpecificInfo.label || defaultLabel
    },
    showMyProgramStatusTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showProgramProgress) {
        return false
      }
      return exploreProgramDetailFlagMap.showProgramProgress.enabled && this.learnerDashboardState.enrollInProgram && this.isCurrentEnrolledProgram
    },
    showMyProgramStatusTabLabel () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showProgramProgress) {
        return 'My Program Status'
      }
      return exploreProgramDetailFlagMap.showProgramProgress.label?exploreProgramDetailFlagMap.showProgramProgress.label:'My Program Status'
    },
    showAlumniTab () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showAlumniData) {
        return false
      }
      return this.alumniData && exploreProgramDetailFlagMap.showAlumniData.enabled
    },
    isCurrentEnrolledProgram () {
      let currentProgram = false
      this.learnerEnrollmentData.forEach(obj => {
        if (obj.programCode === this.programGuideObject.code) {
          currentProgram = true
        }
      })
      return currentProgram
/*
      let userObject = JSON.parse(localStore.getItem('userobj'))
      let userProgram = userObject.major1
      let currentProgram = this.programGuideObject.code
      if (localStore.getItem('userrole') === 'Student') {
        return (userProgram === currentProgram)
      } else {
        return false
      }
*/
    },
    programGuideRouterParams () {
      let programGuide = this.programGuideObject
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type,
        returnTo: this.returnTo || 'exploreProgramGuideResults',
        showBackToResultButton: true,
        isWidget: this.isWidget,
        selected: this.selected
      }
      return routerParams
    },
    programGuideQueryParam () {
      let queryParam = {
        returnTo: this.$route.query.returnTo || this.DEFAULT_RETURN_TO
      }
      return queryParam
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideMenu.vue